<template>
  <div>
    <div class="content-page">
      <div class="content">
        <div class="logo" @click="jump('/', 0)">
          <img class="img" src="@/assets/img/logo.png" alt="" />
        </div>
        <div class="menu">
          <div
            class="menu-item"
            :class="getActive(item)"
            v-for="(item, i) in menu"
            :key="i"
            @click="jump(item.path, i)"
          >
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="visiblePlaceholder" style="width: 100%; height: 100px"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    visiblePlaceholder: { 
      type: Boolean,
      default: true,
    },
  },
  components: {},
  data() {
    return {
      index: 0,
      pointId:'home',
      list: [
        { path: "/home", name: "首页", pointId: "home" },
        { path: "/home", name: "公司简介", pointId: "indexCompanyProfile" },
        { path: "/home", name: "平台信息", pointId: "indexPlatformInfo" },
        { path: "/home", name: "新闻动态", pointId: "indexNews" },
        { path: "/home", name: "政策法规", pointId: "indexPolicies" },
        { path: "/driver", name: "司机中心", role: "DRIVER" },
        { path: "/consignor", name: "货主中心", role: "CUSTOMER" },
        { path: "/carriers", name: "承运商中心", role: "CARRIERS" },
        { path: "/business", name: "业务中心" },
        { path: "/help", name: "帮助中心" },
      ],
      indexList: [
        { path: "/home", name: "首页", pointId: "home" },
        { path: "/home", name: "公司简介", pointId: "indexCompanyProfile" },
        { path: "/home", name: "平台信息", pointId: "indexPlatformInfo" },
        { path: "/home", name: "新闻动态", pointId: "indexNews" },
        { path: "/home", name: "政策法规", pointId: "indexPolicies" },
      ],
      menu: [],
    };
  },
  computed: {
    ...mapState(["isLogin"]),
  },
  watch: {
    isLogin(val) {
      this.setMenu();
    },
  },
  methods: {
    jump(path, i) {
      this.index = i;
      this.$router.push(path);
      if(this.menu[i].pointId){
        this.pointId = this.menu[i].pointId
        this.$emit("anchorPoint",this.menu[i].pointId)
      }else{
        this.$emit("anchorPoint")
      }
    },
    getActive(item){
      let active = ''
      if(item.pointId){
        active = this.pointId==item.pointId?'active':''
      }else{
        active = this.$route.path.includes(item.path)?'active':''
      }
      return active
    },
    setMenu() {
      this.menu = [];
      if (this.isLogin) {
        const role = JSON.parse(localStorage.getItem("userInfo")).currentRole;
        this.list.map((item) => {
          if (!item.role || item.role == role) {
            this.menu.push(item);
          }
        });
      } else {
        this.menu = this.indexList;
      }
    },
  },
  created() {},
  mounted() {
    this.setMenu();
    this.$http.statisticsPlus().then((res) => {
      console.log(res);
    });
  },
};
</script>
<style scoped lang="less">
.content-page {
  position: fixed;
  width: 100%;
  top: 40px;
  left: 0;
  z-index: 8;
  height: 80px;
  background-color: rgba(255, 255, 255, 1);
}
.content {
  margin: 0 auto;
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;

  cursor: pointer;
  .logo {
    display: flex;
    align-items: center;
    .img {
      width: 280px;
      height: auto;
      margin-right: 10px;
    }
  }
  .menu {
    display: flex;
    width: 800px;
    .menu-item {
      flex: 1
    }
    .menu-item:hover {
      color: #409eff;
    }
    .active {
      color: #409eff;
    }
  }
}
</style>
